module.exports = __webpack_public_path__ + "static/media/retrospect.894efb60.png";